<template>
  <h2 id="text" class="my-2 text-justify md:text-center w-11/12 md:w-4/6 text-sm sm:text-base md:text-md lg:text-lg xl:text-xl">{{ text }}</h2>
</template>

<script>
export default {
  name: 'PageDescription',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
#text {
  color: #1f1f1f;
  text-indent: 4rem;
}
</style>
